
import { useStore } from '@/store'
import { defineComponent, computed, watch, ref, onMounted } from 'vue'
import FormOption from '@/components/Form/FormOption.vue'
import { ConfigurationActionTypes } from '@/store/modules/configuration/action-types'
import { ColorpickerActionTypes } from '@/store/modules/colorpicker/action-types'
import insideSettings from '@/settings/inside-settings.json'
import Analytics from '@/singletons/analytics'
import FormScrollableTab from '@/components/Abstract/FormScrollableTab.vue'
import FormColorPicker from '@/components/Form/FormColorPicker.vue'
import StageDeterminerService from '@/services/page/stage-determiner.service'

export default defineComponent({
  name: 'FormInside',
  components: {
    FormScrollableTab,
    FormOption,
    FormColorPicker
  },
  props: {
    index: Number
  },
  setup() {
    let stageDeterminer = new StageDeterminerService()
    const store = useStore()
    const configName = ref('configInsideId')
    const colorpicker = ref("#2e2e2e")
    const showColorPicker = ref(false)
    const config = computed(() => store.getters[configName.value])
    const options = computed(() => insideSettings.futaNoUraTextures)

    onMounted(() => {
      if (stageDeterminer.isColorpickerVisible()) {
        showColorPicker.value = true
      }
    })

    const onClick = (option: any) => {
      store.dispatch(ConfigurationActionTypes.SET_CONFIG_INSIDE, option.id)
      Analytics.instance.sendInsideEvent(option.id)

      colorpicker.value = option.value || "#2e2e2e";
    }

    const onColorPickerUpdate = (val) => {
      store.dispatch(ColorpickerActionTypes.SET_COLORPICKER_INSIDE, val)
    }

    return {
      config,
      configName,
      colorpicker,
      insideSettings,
      options,
      showColorPicker,
      onClick,
      onColorPickerUpdate
    }
  }
})
